import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE, 
});

// Endpoints that must never attach Authorization
const NO_AUTH_PATHS = ['/chat/', 'admin/login/'];

api.interceptors.request.use((config) => {
  const url = config.url || '';

  if (config.headers && config.headers['X-Bypass-Auth'] === '1') {
    if (config.headers.Authorization) delete config.headers.Authorization;
    return config;
  }

  if (NO_AUTH_PATHS.some((p) => url.includes(p))) {
    if (config.headers?.Authorization) delete config.headers.Authorization;
    return config;
  }

  const access = localStorage.getItem('access');
  if (access && config.headers) {
    config.headers.Authorization = `Bearer ${access}`;
  }

  return config;
});

export default api;
